import { ReactElement } from 'react';

interface SiteVisitRecordingStopConfirmModalProps {
	readonly onStop: () => void;
	readonly onContinue: () => void;
}

/** Confirm before stopping visit-form / draft-form recording from the FAB Stop button. */
export function SiteVisitRecordingStopConfirmModal({
	onStop,
	onContinue,
}: Readonly<SiteVisitRecordingStopConfirmModalProps>): ReactElement {
	return (
		<div className="conform-pop">
			<span className="h4">Do you want to stop the recording?</span>

			<div className="button-component">
				<button className="btn btn-primary " type="button" onClick={onContinue}>
					Continue
				</button>

				<button className="btn btn-primary btn-primary-2" type="button" onClick={onStop}>
					Stop
				</button>
			</div>
		</div>
	);
}
